import { css } from '@emotion/react';
import { Box, Divider, Flex, Text, desktopFirstMediaQuery } from '@inflearn/ds-react-next';
import { useTranslation } from 'next-i18next';

const StatsSection = () => {
  const { t } = useTranslation();

  return (
    <Box component="section" css={styleSection}>
      <Box css={styleContainer}>
        <Box css={styleGrid}>
          <Flex
            styles={{
              root: styleRow,
            }}
          >
            <StateItem
              label={t('open.knowledge.stats.total.settlement')}
              value={t('open.knowledge.stats.total.settlement.value')}
            />
            <Divider my="auto" orientation="vertical" size="xs" h={60} color="gray.3" />
            <StateItem
              label={t('open.knowledge.stats.avg.earnings')}
              value={t('open.knowledge.stats.avg.earnings.value')}
            />
          </Flex>
          <Divider
            orientation="vertical"
            size="xs"
            h={60}
            my="auto"
            color="gray.3"
            styles={{
              root: styleDesktopDivider,
            }}
          />
          <Flex
            styles={{
              root: styleRow,
            }}
          >
            <StateItem
              label={t('open.knowledge.stats.instructors')}
              value={t('open.knowledge.stats.instructors.value')}
            />
            <Divider my="auto" orientation="vertical" size="xs" h={60} color="gray.3" />
            <StateItem
              label={t('open.knowledge.stats.students')}
              value={t('open.knowledge.stats.students.value')}
            />
          </Flex>
        </Box>
      </Box>
    </Box>
  );
};

const StateItem = ({ label, value }: { label: string; value: string }) => {
  return (
    <Flex
      direction="column"
      align="center"
      gap={4}
      styles={{
        root: styleStatContent,
      }}
    >
      <Text
        styles={{
          root: styleLabel,
        }}
        fw="500"
        lh="1.5"
        c="infgreen.7"
      >
        {label}
      </Text>
      <Text
        c="gray.9"
        fw={700}
        lh={1.3}
        styles={{
          root: styleValue,
        }}
      >
        {value}
      </Text>
    </Flex>
  );
};

export default StatsSection;

const styleSection = css({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#ffffff',
  paddingBottom: 100,
  width: '100%',
  [desktopFirstMediaQuery.mobile]: {
    paddingBottom: 80,
  },
});

const styleContainer = css({
  maxWidth: 1200,
  width: '100%',
  padding: '0 32px',
  [desktopFirstMediaQuery.mobile]: {
    padding: '0 16px',
  },
});

const styleGrid = css({
  display: 'flex',
  alignItems: 'center',
  gap: 0,
  [desktopFirstMediaQuery.tablet]: {
    flexWrap: 'wrap',
  },
});

const styleRow = css({
  flex: 1,
  alignItems: 'center',
  [desktopFirstMediaQuery.tablet]: {
    flex: '0 0 100%',
  },
});

const styleDesktopDivider = css({
  [desktopFirstMediaQuery.tablet]: {
    display: 'none',
  },
});

const styleStatContent = css({
  flex: 1,
  padding: '32px 0',
  textAlign: 'center',
});

const styleLabel = css({
  fontSize: 20,
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 16,
  },
});

const styleValue = css({
  fontSize: 44,
  fontWeight: 700,
  lineHeight: 1.3,
  [desktopFirstMediaQuery.tablet]: {
    fontSize: 44,
  },
  [desktopFirstMediaQuery.mobile]: {
    fontSize: 26,
  },
});
